module.exports = __webpack_public_path__ + "static/img/weChatRQ.e4e6416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weChatRQ.png
// module id = cSB2
// module chunks = 63